export default function TableCellChip({ value, options }) {
  const caps = options?.caps ?? false;
  let label = caps ? String(value).toUpperCase() : String(value);
  let colorClasses;

  switch (label.toLowerCase()) {
    case "true":
    case "completed":
    case "active":
    case "credit":
    case "resolved":
      colorClasses = "bg-[#D3E5E4] border-[#BDD6D5]";
      break;
    case "false":
    case "pending":
    case "under review":
    case "debit":
      colorClasses = "bg-[#FCF4D4] border-[#FCEEA9]";
      break;

    case "action required":
    case "failed":
      colorClasses = "bg-[#FCDEE6] border-[#FCD4DD]";
      break;
  }

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border-2 ${colorClasses}`}
    >
      {label}
    </span>
  );
}
